import createReducer from "../../createReducer";
import { mailchimpSelectedFieldsHandlers } from "../handlers";
import { IMailchimpSelectedFieldsState } from "../types";

export const getMailchimpSelectedFieldsReducer: IMailchimpSelectedFieldsState = {
    isLoading: false,
    error: null,
    selectedFields: [],
};
export default createReducer(getMailchimpSelectedFieldsReducer, mailchimpSelectedFieldsHandlers);
